import React from "react";

/** Honest empty state used across the app. */
export function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50/60 px-6 py-12 text-center"
    >
      {Icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-slate-200 text-slate-400">
          <Icon className="h-6 w-6" />
        </div>
      )}
      <h3 className="font-heading text-base font-bold text-slate-800">{title}</h3>
      {description && (
        <p className="mt-1.5 max-w-sm text-sm text-slate-500">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

/** Honest "coming in Phase 1b" section placeholder. */
export function Phase1bSection({ title, testid }) {
  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-amber-200 bg-amber-50 p-4"
    >
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-sm font-bold text-amber-900">{title}</h3>
        <span className="rounded-full bg-amber-200/70 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-amber-900">
          Phase 1b
        </span>
      </div>
      <p className="mt-1 text-xs text-amber-800">
        Available from Phase 1b. LeadCTRL shows only real, un-fabricated data — no
        placeholder records here.
      </p>
    </div>
  );
}
